import type { MarketingLocale } from '~/lib/marketing/site';

import { FINAL_CTA } from '../../_lib/platform.content';
import { ScheduleDemoPaths } from '../schedule-demo-paths';

/**
 * Closing call to action, split by situation (new venue vs switching) so each
 * visitor sees the promise that removes their specific hesitation.
 */
export function FinalCtaSection({ locale }: { locale: MarketingLocale }) {
  return (
    <section
      id="demo"
      className="scroll-mt-16 bg-[#202020] px-4 py-16 text-white md:px-8 md:py-24 lg:px-[90px] lg:py-[110px]"
    >
      <div className="mx-auto max-w-[1100px] text-center">
        <h2
          className="font-roboto text-[32px] leading-[1.12] md:text-[44px] lg:text-[52px]"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          {FINAL_CTA.heading[locale]}
        </h2>
        <p className="mx-auto mt-4 max-w-[620px] font-roboto text-[16px] leading-relaxed text-white/65 md:text-[18px]">
          {FINAL_CTA.description[locale]}
        </p>
        <div className="mt-12">
          <ScheduleDemoPaths locale={locale} />
        </div>
      </div>
    </section>
  );
}
